'use client';
import React, { useEffect } from 'react';
import { Header, HeroSection } from '@/components/cullertons/HeaderHero';
import LocalitySection from '@/components/cullertons/LocalitySection';
import QuoteSection from '@/components/cullertons/QuoteSection';
import AboutSection from '@/components/cullertons/AboutSection';
import ApproachSection from '@/components/cullertons/ApproachSection';
import ValuationSection from '@/components/cullertons/ValuationSection';
import Footer from '@/components/cullertons/Footer';

export default function HomePage() {
  useEffect(() => {
    // Reveal on scroll
    const revealEls = document.querySelectorAll('.reveal');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
    );
    revealEls.forEach((el) => observer.observe(el));

    // Hero text reveal
    const heroTitle = document.getElementById('hero-title');
    if (heroTitle) {
      heroTitle.classList.add('reveal-active');
    }

    // Scroll scrub text
    const scrubEls = document.querySelectorAll('.scroll-scrub-text');
    const scrubObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target as HTMLElement;
            const ratio = entry.intersectionRatio;
            const pos = 100 - ratio * 100;
            el.style.backgroundPosition = `${pos}% 0`;
          }
        });
      },
      { threshold: Array.from({ length: 101 }, (_, i) => i / 100) }
    );
    scrubEls.forEach((el) => scrubObserver.observe(el));

    // Parallax dots
    const dots = document.getElementById('parallax-dots');
    const handleMouseMove = (e: MouseEvent) => {
      if (!dots) return;
      const x = (e.clientX / window.innerWidth - 0.5) * 20;
      const y = (e.clientY / window.innerHeight - 0.5) * 20;
      dots.style.transform = `translate(${x}px, ${y}px)`;
    };
    window.addEventListener('mousemove', handleMouseMove);

    // Spotlight cards
    const handleSpotlight = (e: MouseEvent) => {
      const cards = document.querySelectorAll('.spotlight-card');
      cards.forEach((card) => {
        const rect = (card as HTMLElement).getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        (card as HTMLElement).style.setProperty('--mouse-x', `${x}px`);
        (card as HTMLElement).style.setProperty('--mouse-y', `${y}px`);
      });
    };
    window.addEventListener('mousemove', handleSpotlight);

    return () => {
      observer.disconnect();
      scrubObserver.disconnect();
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mousemove', handleSpotlight);
    };
  }, []);

  return (
    <main className="relative bg-cream">
      <div id="parallax-dots" aria-hidden="true" />
      <Header />
      <HeroSection />
      <LocalitySection />
      <QuoteSection />
      <AboutSection />
      <ApproachSection />
      <ValuationSection />
      <Footer />
    </main>
  );
}
